// src/components/visualizations/VisualizationPanel.vue

<template>
  <v-navigation-drawer v-model="drawer" app  class="mt-8" right stateless width="400">
    <v-layout row wrap class="mt-6 ma-0 pa-2">
      <!-- Charts Section -->
      <v-flex xs12 class="mb-4">
        <ChartPanel />
      </v-flex>

      <!-- Table Section -->
      <v-flex xs12>
        <DataTable />
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import ChartPanel from './ChartPanel.vue';
import DataTable from './DataTable.vue';

export default {
  name: 'VisualizationPanel',

  components: {
    ChartPanel,
    DataTable
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>